/**
 * Property-specific labels for "Property Assistant" and "Leasing Consultant"
 * in the application flow. Matches Angular behavior for certain properties.
 * See plan: Amalfi at Tuscan Lakes, Bridgewater Grand, Liberty 1 use different names.
 */

const PROPERTY_AGENT_LABEL_OVERRIDES: Record<
  string,
  { propertyAssistantLabel?: string; leasingConsultantLabel?: string }
> = {
  "Amalfi at Tuscan Lakes": {
    propertyAssistantLabel: "Community Manager",
    leasingConsultantLabel: "Community Manager", // shown on form for this property
  },
  "Bridgewater Grand": {
    propertyAssistantLabel: "Community Manager",
    leasingConsultantLabel: "Community Manager",
  },
  "Liberty 1": {
    propertyAssistantLabel: "Community Manager",
    leasingConsultantLabel: "Community Manager",
  },
  // Alias in case API returns "Liberty 1st"
  "Liberty 1st": {
    propertyAssistantLabel: "Community Manager",
    leasingConsultantLabel: "Community Manager",
  },
};

const DEFAULT_PROPERTY_ASSISTANT_LABEL = "Property Assistant";
const DEFAULT_LEASING_CONSULTANT_LABEL = "Leasing Consultant";

/**
 * Normalize property name for lookup (trim, case-insensitive match).
 */
function normalizePropertyName(name: string | undefined | null): string {
  if (name == null || typeof name !== "string") return "";
  return name.trim();
}

/**
 * Get display labels for Property Assistant and Leasing Consultant
 * for the given property (by name or id). Used in application property step
 * and application detail Property tab.
 */
export function getPropertyAgentLabels(
  propertyName?: string | null,
  _propertyId?: string | number | null
): { propertyAssistantLabel: string; leasingConsultantLabel: string } {
  const name = normalizePropertyName(propertyName);
  if (!name) {
    return {
      propertyAssistantLabel: DEFAULT_PROPERTY_ASSISTANT_LABEL,
      leasingConsultantLabel: DEFAULT_LEASING_CONSULTANT_LABEL,
    };
  }
  // Match by exact key or case-insensitive
  const key = Object.keys(PROPERTY_AGENT_LABEL_OVERRIDES).find(
    (k) => k.toLowerCase() === name.toLowerCase() || k === name
  );
  const overrides = key ? PROPERTY_AGENT_LABEL_OVERRIDES[key] : undefined;
  return {
    propertyAssistantLabel:
      overrides?.propertyAssistantLabel ?? DEFAULT_PROPERTY_ASSISTANT_LABEL,
    leasingConsultantLabel:
      overrides?.leasingConsultantLabel ?? DEFAULT_LEASING_CONSULTANT_LABEL,
  };
}
